module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-11.4a3c1ded.png";